import React, { useEffect, useState } from "react";

interface props {
    value: number;
    row: number;
    col: number;
    setReset: boolean;
    setActive: (isActive: boolean, row: number, col: number, value: number) => void;
}

const Field = (props: props) => {

    const [isActive, setIsActive] = useState<boolean>(false);
    const [className, setClassName] = useState<string>('field');

    const toggleActive = () => {
        setIsActive(!isActive);
    };

    useEffect(() => {
        props.setActive(isActive, props.row, props.col, props.value);

        if (isActive) {
            setClassName('field active');
            return;
        }

        setClassName('field');

    }, [isActive]);

    useEffect(() => {
        setIsActive(false);
    },[props.value]);

    useEffect(() => {
        if (!props.setReset) {
            return;
        }

        setIsActive(false);
    }, [props.setReset]);
    
    return (<div className={className}>
        <span onClick={toggleActive}>{props.value}</span>
    </div>);
};

export { Field };
